import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M3_PointersAndFunctions = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Pointers and Functions"
    videos={[
      "https://www.youtube.com/embed/k4CrwUkziGY",
      "https://www.youtube.com/embed/GY-H2jenPRo",
    ]}
    takeaways={[
      {
        text: "This includes the call by reference functions.",
      },
      {
        text: "Expect coding questions from this section (they may involve writing code directly, debugging the code, or writing the output of the code).",
      },
    ]}
    questions={[
      
    ]}
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M3_PointersAndFunctions;
